/* eslint-disable */
/*
 * AppReducer
 *
 * The reducer takes care of our data. Using actions, we can change our
 * application state.
 * To add a new action, add it to the switch statement in the reducer function
 *
 * Example:
 * case YOUR_ACTION_CONSTANT:
 *   return state.set('yourStateVariable', true);
 */

import { fromJS } from 'immutable';
import merge from 'lodash/merge';

import {
  SUBMIT_REDEMPTION_SUCCESS,
  CANCEL_REDEMPTION_SUCCESS,
} from 'containers/RewardRedeemDetailsPage/constants';

import {
  RESET_ERROR,
  SIGN_IN,
  LOAD_USER,
  LOAD_USER_SUCCESS,
  LOAD_INITIAL_DATA_SUCCESS,
  ADD_REDEMPTION_DATA,
  SET_LOCATION,
  TTLOGGER_SET_USER_ID,
  LOAD_USER_IMAGE_SUCCESS,
  SEND_MAIL_SUCCESS,
  ACCEPT_TOS_SUCCESS,
  ACCEPT_PRIVACY_SUCCESS,
  LOAD_ACCEPTED_PAGES,
  VALIDATION_ERRORS,
  RESET_VALIDATION_ERROR,
} from './constants';

import registerCaregiverAction from 'containers/RegisterCaregiver/actions'

import registerGirslAction from 'containers/RegisterGirls/actions'

import {
  LOAD_TERMS_PAGE,
  LOAD_TERMS_PAGE_SUCCESS,
  LOAD_TERMS_PAGE_ERROR,
} from 'containers/TosPage/constants'


import {
  LOAD_PRIVACY_PAGE,
  LOAD_PRIVACY_PAGE_SUCCESS,
  LOAD_PRIVACY_PAGE_ERROR,
} from 'containers/PrivacyPage/constants'

import {
  LOAD_FAQ_PAGE,
  LOAD_FAQ_PAGE_SUCCESS,
  LOAD_FAQ_PAGE_ERROR,
} from 'containers/FaqPageDynamic/constants'


// The initial state of the App
const initialState = fromJS({
  loading: false,
  error: false,
  customErrorMsg: '',
  user: false,
  categories: false,
  redemtionData: false,
  latitude: null,
  longitude: null,
  ttloggerUserId: null,
  acceptedTos: false,
  acceptedPrivacy: false,
  htmlContent: '',
});

function appReducer(state = initialState, action) {
  // errors
  if (action.error) {
    return state
      .set('error', action.error)
      .set('loading', false);
  }
  // loading
  if (action.loading) {
    return state
      .set('loading', action.loading);
  }

  switch (action.type) {
    // load initial data
    case LOAD_INITIAL_DATA_SUCCESS:
      {
        const { response: { categories, profiles } } = action;
        return state
          .set('categories', categories)
          .set('profiles', profiles);
      }
    // clear user
    case SIGN_IN:
    case LOAD_USER:
      return state
        .set('user', false)
        .set('acceptedTos', false)
        .set('acceptedPrivacy', false);
    // set user
    case LOAD_USER_SUCCESS:
      return state
        .set('user', action.response);
    // reset error
    case RESET_ERROR:
      return state
        .set('error', false);
    // redemption data
    case ADD_REDEMPTION_DATA:
      return state
        .set('redemtionData', merge({}, state.get('redemtionData'), action.data));
    case SUBMIT_REDEMPTION_SUCCESS:
    case CANCEL_REDEMPTION_SUCCESS:
      return state
        .set('redemtionData', false);
    case SET_LOCATION:
      return state
        .set('latitude', action.latitude)
        .set('longitude', action.longitude);
    case TTLOGGER_SET_USER_ID:
      return state
        .set('ttloggerUserId', action.ttloggerUserId);
    case LOAD_USER_IMAGE_SUCCESS:
      return state
        .set('user', { ...state.get('user'), userImage: action.response });
    case SEND_MAIL_SUCCESS:
      return state
        .set('successMail', action.response);
    case ACCEPT_TOS_SUCCESS:
      return state
        .set('acceptedTos', true)
        .set('user', { ...state.get('user'), isTosAccepted: '1' });
    case ACCEPT_PRIVACY_SUCCESS:
      return state
        .set('acceptedPrivacy', true)
        .set('user', { ...state.get('user'), isPpAccepted: '1' });
    case LOAD_ACCEPTED_PAGES:
      let isPpAccepted = 0;
      let isTosAccepted = 0;
      if (action.response) {
        isPpAccepted = action.response.isPpAccepted;
        isTosAccepted = action.response.isTosAccepted;
      }
      return state
        .set('acceptedPrivacy', Boolean(Number(isPpAccepted)))
        .set('acceptedTos', Boolean(Number(isTosAccepted)));
    case VALIDATION_ERRORS:

      return state
        .set('error', true)
        .set('customErrorMsg', action.customerror.message)
        .set('loading', false);
    case RESET_VALIDATION_ERROR:
      //  debugger;
      return state
        .set('error', false)
        .set('customErrorMsg', '')
        .set('loading', false);
    // reset error
    case registerCaregiverAction.REQUEST:
    case registerGirslAction.REQUEST:
      return state
        .set('loading', true);
    case registerCaregiverAction.SUCCESS:
    case registerGirslAction.SUCCESS:
      return state
        .set('loading', false);
    case registerCaregiverAction.FAILURE:
    case registerGirslAction.FAILURE:
      return state
        .set('error', true)
        .set('customErrorMsg', action.payload)
        .set('loading', false);
    case LOAD_TERMS_PAGE:
    case LOAD_PRIVACY_PAGE:
      return state
        .set('loading', true)
        .set('error', false)
        .set('htmlContent', '');
    case LOAD_TERMS_PAGE_SUCCESS:
    case LOAD_PRIVACY_PAGE_SUCCESS:
      return state
        .set('loading', false)
        .set('htmlContent', action.response.content);
    case LOAD_TERMS_PAGE_ERROR:
    case LOAD_PRIVACY_PAGE_ERROR:
      return state
        .set('error', action.error)
        .set('loading', false);
    case LOAD_FAQ_PAGE:
      return state
        .set('loading', true)
        .set('error', false)
        .set('htmlContent', '');
    case LOAD_FAQ_PAGE_SUCCESS:
      return state
        .set('loading', false)
        .set('htmlContent', action.response.content);
    case LOAD_FAQ_PAGE_ERROR:
      return state
        .set('error', action.error)
        .set('loading', false);
    default:
      return state
        .set('loading', false);
  }
}

export default appReducer;
